// src/components/wallets/BaseWallet.tsx
import React, { ReactElement, useState } from 'react'
import Box from '@/components/boxes/Box'
import { PersonalWallet } from '@/database/personalwallet'
import { uni1d800 } from '@/utils/extras'
import { VaultWallet } from '@/database/vaultwallet'
import { shortenAddress, urlFromAddress } from '@/utils/shortenAddress'
import Url from '@/components/boxes/Url'
import { GoLinkExternal } from 'react-icons/go'
import Link from 'next/link'

interface BaseWalletProps {
    wallet: PersonalWallet | VaultWallet
    title: string
    controller: string
}

const BaseWalletDetails = React.memo(({ wallet, title, controller }: BaseWalletProps): ReactElement => {
    const [showTooltip, setShowTooltip] = useState(false)

    return (
        <div className="header-container center bottom">
            <div className="artwork-box center width-hundred max-width-370 margin-box">
                <div className={'header-container gradient-text bold large-bold'}>
                    <Box caption={title} text={''} styleCaption={'gradient-text bold large-bold'} />
                </div>
                {controller && <div className={'gray bottom'}>{controller}</div>}
                <div className={'nav__balances header-container bottom'}>
                    <Box
                        caption={Url('Address', wallet.address, setShowTooltip, showTooltip)}
                        styleCaption={uni1d800.className + ' center small gray'}
                        styleText={'center'}
                        text={shortenAddress(wallet.address)}
                        triggerAnimation={false}
                    />
                </div>
                <div className={'nav__balances header-container bottom'}>
                    <Box
                        caption={'\uD836\uDE17CRAZY\u200C\uD836\uDE17'}
                        styleCaption={uni1d800.className + ' center small'}
                        styleText={'center'}
                        text={wallet.tokenBalances[0] ? wallet.tokenBalances[0].balance : '0'}
                    />
                    <Box
                        caption={'PLS'}
                        styleCaption={uni1d800.className + ' center small'}
                        styleText={'center'}
                        text={wallet.pulse}
                    />
                </div>
                <div className={'nav__balances header-container bottom'}>
                    <Box
                        caption={
                        <Link
                            href={urlFromAddress(wallet.address)}
                            className={'z-index-hundred'}
                            target="_blank"
                            rel="noopener noreferrer"
                            passHref={true}
                        >
                            <GoLinkExternal className="social-media-icon margin-top-five gray " />
                        </Link>
                        }
                        styleCaption={uni1d800.className + ' center small'}
                        styleText={'center'}
                        text={
                            <Link
                                href={urlFromAddress(wallet.address)}
                                className={'z-index-hundred'}
                                target="_blank"
                                rel="noopener noreferrer"
                                passHref={true}
                            >
                                Tokens &amp; NFT&apos;s
                            </Link>
                        }
                    />
                </div>
            </div>
        </div>
    )
})

BaseWalletDetails.displayName = 'BaseWalletDetails'

export default BaseWalletDetails
